import React, { Component } from "react";
import { Button, Col, Form, Input, Row, Spin } from "antd";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import projectStore from "../store/ProjectStore";
import CompanyStore from "../store/CompanyStore";


class ProjectAdd extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = { loadingSpin: false, Id: -1, companyId: "", projectId: -1 };
    this.projectStore = new projectStore();
    this.companyStore = new CompanyStore(this);
    
  }

  async componentDidMount() {

    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
    }
    const projectId = this.props.projectId;
    const companyId = this.props.companyId;
    console.log("project Id", projectId)
    if (projectId) {
      await this.filldata(projectId, companyId);
    }

    this.setState({ update: 1 });
  }
  async handleChange(comp) {
    await this.setState({ companyId: comp.value });

  }
  async filldata(projectId, companyId) {
    const getProjectData = await this.projectStore.getProjectDetails(companyId, projectId);

    await this.setState({ Id: getProjectData.projectId, companyId: companyId,projectId: projectId});
    const singleData = await this.companyStore.getCompanyDataById(
      getProjectData[0].companyId
    );
    await this.formRef.current.setFieldsValue({
      Id: getProjectData[0].projectId,
      projectName: getProjectData[0].projectName,
      companyId: singleData
    });
  }

  onProjectSubmit = async (values) => {
    const data = { project: {proname: values.projectName, companyId: this.state.companyId , projectId: this.state.projectId} };
    console.log(data)
    const response = await this.projectStore.addProjectData(data);
    await this.projectStore.getProjectDetails(this.state.companyId);
    console.log(response);

    await this.props.response(response);
    this.setState({ loading: false });
    this.formRef.current?.resetFields();
    this.props.closeModal();
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0 }}>
        <div style={{ paddingBottom: "10px" }}>
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onProjectSubmit}
              style={{ maxWidth: "100%", padding: 0 }}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <>
                        <Form.Item
                          name="companyId"
                          // label="Account"
                          label={this.context.translate("_ACCOUNT_")}
                          rules={[{ required: true }]}
                        >
                          <CompanyAutocomplete
                            onChange={(value) => {
                              this.handleChange(value);
                            }}
                            companyId={this.state.companyId}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </>
                    )}
                  <Form.Item
                    name="projectName"
                    label={this.context.translate("_PROJECT_NAME_")}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <div className="formBtnGroup">
                <Button
                  className="formCancelButton"
                  onClick={(e) => {
                    this.closeModal();
                  }}
                >
                  {this.context.translate("_FLEET_CLOSE_BTN_")}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.loading}
                  className="formSaveButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}
ProjectAdd.contextType = StoreContext;
export default observer(withRouter(ProjectAdd));
